<template>
  <footer id='Main' v-once v-if='kirby.site.content && "block_1" in kirby.site.content'>
    <section>
      <summary v-html='kirby.site.content.block_1.kirbytext' />
      <small v-html='kirby.site.content.block_1_small.kirbytext' />
    </section>
    <section id="mailchimp">
      <summary v-html='kirby.site.content.block_2.kirbytext' />
      <small v-html='kirby.site.content.block_2_small.kirbytext' />
    </section>
    <section>
      <figure>
        <a href="https://pennmedicine.org">
          <PennLogo />
        </a>
      </figure>
      <small v-html='kirby.site.content.block_3_small.kirbytext' />
    </section>
  </footer>
</template>

<script>
import mixins from '.././mixins.js';
export default {
  mixins: [mixins], //kirby(), urltopath(), etc
}
</script>

<style scoped>
  footer {
      padding: 4rem 2rem;
      max-width: var(--main-max-width);
      display: flex;
      flex-direction: var(--columns-or-rows);
      margin: 2rem auto;
      box-sizing: border-box;
      gap: 2em;
  }

  section {
    flex-grow: 1;
    flex-basis: 0;
    box-sizing: border-box;
  }

  figure {
    height: 2.25em;
    margin: 0;
    padding: 0;
  }

  small {
    display: block;
  }
</style>

<style>
  footer#Main section#mailchimp h2 {
    font-size: inherit;
  }

  footer#Main p {
    max-width: 23em;
    margin-bottom: 1.25rem;
  }

  small p {
    letter-spacing: 0.07em;
  }
</style>
